var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconPrizeDrawWin48(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PrizeDrawWin48",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    opacity: 0,
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.055305, 6.000000)",
    stroke: "#1E1E1E"
  }, /*#__PURE__*/React.createElement("g", {
    id: "trophy",
    transform: "translate(3.944695, 10.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,0 L17,0 L17,10 C17,13.8659932 13.8659932,17 10,17 C6.13400675,17 3,13.8659932 3,10 L3,0 L3,0 Z",
    id: "Rectangle",
    fill: "#FAEC20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1,4 L4,4 L4,4.5 C4,5.88071187 2.88071187,7 1.5,7 C0.119288125,7 -1,5.88071187 -1,4.5 L-1,4 L-1,4 Z",
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(1.500000, 5.500000) rotate(90.000000) translate(-1.500000, -5.500000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,4 L21,4 L21,4.5 C21,5.88071187 19.8807119,7 18.5,7 C17.1192881,7 16,5.88071187 16,4.5 L16,4 L16,4 Z",
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(18.500000, 5.500000) scale(-1, 1) rotate(90.000000) translate(-18.500000, -5.500000) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.5,
    y1: 17,
    x2: 10.5,
    y2: 23,
    id: "Path-7"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 22.5,
    x2: 15,
    y2: 22.5,
    id: "Path-8"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 3.48617365,
    y1: 9.24059476,
    x2: 0.498024807,
    y2: 8.24454515,
    id: "Line-3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 27.3913644,
    y1: 9.24059476,
    x2: 24.4032155,
    y2: 8.24454515,
    id: "Line-3",
    transform: "translate(25.897290, 8.742570) scale(-1, 1) translate(-25.897290, -8.742570) "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(5.944695, 0.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 1.5,
    y1: 5.5,
    x2: 0.5,
    y2: 2.5,
    id: "Line-3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.5,
    y1: 5.5,
    x2: 14.5,
    y2: 2.5,
    id: "Line-3",
    transform: "translate(15.000000, 4.000000) scale(-1, 1) translate(-15.000000, -4.000000) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.5,
    y1: 4,
    x2: 8.5,
    y2: 0,
    id: "Line"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconPrizeDrawWin48);
export default __webpack_public_path__ + "static/media/pictogramBeaconPrizeDrawWin48.d99c0682b1ffcae96595492ca9b7d0fe.svg";
export { ForwardRef as ReactComponent };